module.exports = __webpack_public_path__ + "static/media/baby.a5db61f7.svg";